import columns from '../../../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';

export function getDetailsTabNavOptions(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.PREDES_COMPLIANCE_MISSING_REQUIRED_ELEMENTS_DETAILS.id,
    mainReportId: ReportDefinitions.PREDES_COMPLIANCE_MISSING_REQUIRED_ELEMENTS_SUMMARY.id,
    requestParams: {
      operatorFrom: rowInfo.row['originOperator'],
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    NavigationColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Origin operator', 'originOperator'),
        new NonZeroNumberColumn('Despatches', 'despatches'),
        new NavigationColumn(new NonZeroNumberColumn('Receptacles', 'receptacles'), getDetailsTabNavOptions),
        new NonZeroNumberColumn('Despatches affected', 'despatchesAffected'),
        new NonZeroNumberColumn('Departure location', 'departureLoc'),
        new NonZeroNumberColumn('Departure date', 'departureDate'),
        new NonZeroNumberColumn('Arrival date', 'arrivalDate'),
        new NonZeroNumberColumn('Receptacle item', 'receptacleItem'),
        new NonZeroNumberColumn('Weight', 'weight'),
        new NonZeroNumberColumn('Weight type', 'weightType'),
        new NonZeroNumberColumn('Receptacle type', 'receptacleType'),
        new NonZeroNumberColumn('Receptacle format', 'receptacleFormat'),
      ],
    },
  ];
};
